// components/TopPicksSection/TopPicksSection.tsx
import React from 'react';
import { Container } from 'reactstrap';
import TopPicks from '@/components/Grids/TopPicks/TopPicks';
import { AssetProps } from '@/libs/interfaceProps/assetProps';
import { ParamsProps } from '@/libs/interfaceProps/paramsProps';
import { useTranslations } from 'next-intl';
interface ValidationParamsType {
  customerLinks: boolean;
  leadDropValidation: boolean;
  peDemandSub: boolean;
}
interface TopPicksSectionProps {
  /**
   * Translation function
   */
  t: ReturnType<typeof useTranslations>;

  /**
   * Response data containing asset information
   */
  responseData: AssetProps;

  /**
   * Resource ID
   */
  resId: string;

  /**
   * Validation parameters
   */
  validationParams?: ValidationParamsType;

  /**
   * Query parameters string to append to URLs
   */
  queryParams: string;

  /**
   * URL parameters including language
   */
  params: ParamsProps;
}

/**
 * TopPicksSection component displays related content recommendations
 * from the same organization as the current asset
 */
const TopPicksSection: React.FC<TopPicksSectionProps> = ({
  t,
  responseData,
  resId,
  validationParams,
  queryParams,
  params
}) => <>
  <Container className={'section-dividers'} data-sentry-element="Container" data-sentry-source-file="TopPicksSection.tsx">
   <hr />
  </Container>
  <Container className={'bottom-download-grid'} data-sentry-element="Container" data-sentry-source-file="TopPicksSection.tsx">
   <TopPicks sectionHeadingTitle={`${t('TopPicks')} from ${responseData.orgName}`} orgId={responseData?.orgId} resId={resId} validationParams={validationParams} utmParams={queryParams} lang={params.lang} data-sentry-element="TopPicks" data-sentry-source-file="TopPicksSection.tsx" />
  </Container>
 </>;
export default TopPicksSection;